---
id: 'openpipe-training-inference-migrating-to-wandb'
title: 'OpenPipe training and inference migrating to W&B'
excerpt: 'OpenPipe training and inference are migrating to W&B, and the legacy OpenPipe platform will stop supporting new training and inference on July 30, 2026.'
date: 'May 18, 2026'
category: 'News'
readTime: '3'
author: 'Kyle and David Corbitt'
featured: true
draft: false
---

Last September, OpenPipe [joined CoreWeave/Weights and Biases](https://openpipe.ai/blog/openpipe-coreweave). Since that time we’ve been actively working to bring what makes the OpenPipe platform great to the larger CoreWeave customer base.

That process is now complete, with the important OpenPipe platform features now fully implemented, and in most cases improved, within the Weights and Biases platform itself. As a result, we are **deprecating the legacy OpenPipe platform**. Effective **July 30, 2026**, it will no longer be possible to train new models or perform inference on existing models on OpenPipe.ai. We have provided a migration tool to automatically bring your existing models to W&B that we’ll share below.

While we know that transitions are hard, we’re excited about the new functionality that the [W&B Training](https://docs.wandb.ai/serverless-rl/sft) and [Inference](https://wandb.ai/site/inference/) products bring. Compared to OpenPipe, the new product surfaces feature:

- Newer models
- Faster, cheaper training
- Faster, cheaper inference
- Native support for [reinforcement learning](https://openpipe.ai/blog/serverless-rl) that you can seamlessly mix with your SFT jobs

## Next Steps

We’ve worked hard to make the transition as simple as possible—it should only take a few minutes of your (or your agent’s!) time. Our automated migration tool can take your existing models and move them to W&B Inference

1. Sign into your [OpenPipe account](https://app.openpipe.ai/).
2. You will see a new permanent banner noting the migration. Click the “Migrate” button.
3. A modal will appear that walks you through the process of creating your W&B account and migrating all models to it.

## Deprecated Features

While the core training and inference workloads can be fully migrated, other infrequently-used platform features will be sunset with the shut down of OpenPipe. If you have important data related to any of the following features, be sure to remove it before the July 30 deadline:

- Reward Models
- Managed Evaluations
- Criteria
- Pruning Rules
- “Data Pipelines” (Relabeling Workflows)
- DPO

## Migration Support

Our team is eager to make this transition as easy and successful as possible. If you have any trouble with the migration tool or are unsure how to replicate some part of your workflow with the new product surface, please reach out to support@openpipe.ai! We’ll make sure to help.

## From the Founders

On a personal note, it has been our privilege to work with all of you throughout this journey and see the amazing models you’ve built and deployed to millions of users. While our product shape is changing, we look forward to continuing to build even bigger things with you in the future.

Sincerely,

Kyle and David Corbitt
